(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tf-chat-controls"] && !Shopify.designMode) return;
  try {
    const tfChatHide=document.getElementById('tf-chat-hide');
const tfChatKey='tf-chat-hidden';
let tfChatHidden=false;
try{tfChatHidden=sessionStorage.getItem(tfChatKey)==='1'}catch{}
document.documentElement.classList.toggle('tf-chat-hidden',tfChatHidden);
function tfFindChatButton(root){
  if(!root)return null;
  const button=root.querySelector('button[part~="activator"]');
  if(button)return button;
  for(const child of root.querySelectorAll('*')){
    if(child.shadowRoot){const found=tfFindChatButton(child.shadowRoot);if(found)return found}
  }
  return null;
}
let tfChatHost,tfChatActivator,tfChatFrame;
function tfRememberChat(hidden){
  tfChatHidden=hidden;
  document.documentElement.classList.toggle('tf-chat-hidden',hidden);
  try{sessionStorage.setItem(tfChatKey,hidden?'1':'0')}catch{}
}
function tfPositionChatHide(){
  if(!tfChatHide||!tfChatActivator)return;
  const box=tfChatActivator.getBoundingClientRect();
  const expanded=tfChatActivator.getAttribute('aria-expanded')==='true';
  tfChatHide.hidden=tfChatHidden||expanded||box.width===0||box.height===0;
  if(tfChatHide.hidden)return;
  tfChatHide.style.left=Math.max(8,Math.min(innerWidth-40,box.right-12))+'px';
  tfChatHide.style.top=Math.max(8,Math.min(innerHeight-40,box.top-24))+'px';
}
function tfScheduleChatPosition(){
  cancelAnimationFrame(tfChatFrame);
  tfChatFrame=requestAnimationFrame(tfPositionChatHide);
}
function tfConnectChat(){
  const host=document.querySelector('shopify-chat');
  const activator=tfFindChatButton(host?.shadowRoot);
  if(!host||!activator)return false;
  if(activator===tfChatActivator)return true;
  tfChatHost=host;tfChatActivator=activator;
  document.querySelectorAll('.tf-chat-reopen').forEach(button=>button.hidden=false);
  new MutationObserver(tfScheduleChatPosition).observe(activator,{attributes:true,attributeFilter:['aria-expanded','class','style']});
  new ResizeObserver(tfScheduleChatPosition).observe(activator);
  tfScheduleChatPosition();
  return true;
}
tfChatHide?.addEventListener('click',()=>{
  tfRememberChat(true);tfPositionChatHide();
  const shell=document.querySelector('.tf-nav-shell');
  const focusTarget=shell?.open?shell.querySelector('.tf-chat-reopen'):shell?.querySelector('summary');
  focusTarget?.focus({preventScroll:true});
});
document.addEventListener('click',event=>{
  const trigger=event.target.closest('.tf-chat-reopen');
  if(!trigger)return;
  if(!tfConnectChat())return;
  tfRememberChat(false);
  document.querySelectorAll('.tf-nav-group').forEach(group=>group.open=false);
  const shell=trigger.closest('.tf-nav-shell');
  if(shell&&matchMedia('(max-width:1023px)').matches)shell.open=false;
  requestAnimationFrame(()=>{
    if(tfChatActivator.getAttribute('aria-expanded')!=='true')tfChatActivator.click();
    tfScheduleChatPosition();
  });
});
window.addEventListener('resize',tfScheduleChatPosition,{passive:true});
window.addEventListener('scroll',tfScheduleChatPosition,{passive:true});
window.addEventListener('pageshow',tfScheduleChatPosition);
document.addEventListener('shopify:section:load',()=>{document.querySelectorAll('.tf-chat-reopen').forEach(button=>button.hidden=!tfChatActivator)});
let tfChatAttempts=0;
if(!tfConnectChat()){
  const timer=setInterval(()=>{if(tfConnectChat()||++tfChatAttempts>=120)clearInterval(timer)},500);
}
  } catch(e) { console.error(e); }
})();

})();
